import requireTrueBaseValidator from './requireTrue';

export default requireTrueBaseValidator;
